export default [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      resource: 'Default',
      action: 'Read',
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'At a glance',
          active: true,
        },
      ],
    },
  },
]
